import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "app-survey-radio",
  templateUrl: "./survey-radio.component.html",
  styleUrls: ["./survey-radio.component.scss"],
  standalone: false
})
export class SurveyRadioComponent implements OnInit {
  @Input() questionDetails: any;
  @Output() answerSelectedEvent = new EventEmitter<any>();

  activeIndex: number;
  constructor() {
    console.log("Survey radio component loaded.");
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.questionDetails.hasOwnProperty("SelectedAnswer")) {
      this.activeIndex = this.questionDetails.SelectedAnswer.Index;
    }
    else {
      this.activeIndex = -1;
    }
  }

  answerSelected(questionId: string, answer: any, index: number): void {
    answer.QuestionId = questionId;
    answer.Index = index;
    this.activeIndex = index;
    this.questionDetails.SelectedAnswer = answer;
    this.answerSelectedEvent.emit(answer);
  }
}
